import { formatDate } from './formatDate';

export function formatValue(
  value: string | number | boolean | Date | Record<string, unknown> | null | undefined,
  options?: { dataType?: string; nullDisplay?: string },
): string {
  const nullDisplay = options?.nullDisplay ?? '-';
  if (value === null || value === undefined) return nullDisplay;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';

  if (options?.dataType === 'date' && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
    return formatDate(value) || nullDisplay;
  }
  if (value instanceof Date) {
    return formatDate(value) || nullDisplay;
  }

  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  return String(value);
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function pluralizeEntityType(type: string): string {
  return type === 'assay' ? 'Assays' : `${capitalize(type)}s`;
}

/**
 * Format analytical result values (elements, concentrations) for display.
 * Handles special strings like N.D., N.A., and < thresholds.
 */
export function formatAnalyticalValue(value: any): string {
  if (value === null || value === undefined) return '-';
  if (value === 'N.A.') return '-';
  if (value === 'N.D.') return value;
  if (typeof value === 'string' && value.startsWith('<')) return value;
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return String(value);
  if (Math.abs(num) < 0.01 && num !== 0) return num.toExponential(3);
  return num.toLocaleString(undefined, { maximumFractionDigits: 4 });
}
